export const yearStromGesamt = {
    YearStromGesamtClass: {
        url: "StromVerbrauch/gesamtjahr",
        defaultSegment: "StromVerbrauch",
        forceRefresh: false,
        receiveType: 'RECEIVE_BarYearStromGesamt_yearStromGesamtReducer'
    }
};